import React, { Component } from 'react';
import {Grid} from 'semantic-ui-react';
import '../../assets/css/home.css';
import FeaturedTourThumb from "./../home/FeaturedTourThumb.js";
import {Redirect} from 'react-router';
import data from '../../assets/json/tours/tours.json';


export default class ListOfTours extends Component {
	constructor(props){
		super(props);
		this.state = {
			data: data.tours,
			tourCount: Object.keys(data.tours).length
		};
	}
	
	getDefaults = () => {
		let d = data.tours;
		return d.filter((item) => item.active === 'true')[0];
	}

	onThumbnailClick = (img, index) => {
		const itemCount = this.state.tourCount;
		let d = this.state.data;
		
		for (var i = 0; i < itemCount; ++i) {
			if(i === index){
				d[i].active = "true";
			}
			else{
				d[i].active = "false";
			}
		}
				
		this.setState({
			title: img.title,
			thumbnail: img.thumbnail,
			description: img.description,
			days:img.days,
			href: img.href,
			tour: d,
		});
	}
	
  render() {
		let {redirect, data, href} = this.state;
		return(
			<>
				{ redirect && <Redirect push to={href}/> }
				
				<Grid className="tour-details-wrapper">
					{
						data.map(
							(img, i) => (
								<Grid.Column computer={6} tablet={8} mobile={16} className= {data[i].active === "true" ? "thumb-wrapper active" : "thumb-wrapper"} key={i} onClick={() => this.onThumbnailClick(img, i)}>
									<FeaturedTourThumb
										className="thumb"
										index={i}
										name={img.title}
										thumbnail={img.thumbnail}
										description={img.description}
										days={img.days}
										href={img.href}
										data={data}
									/>
									
								</Grid.Column>
							)
						)
					}
				</Grid>
			</>
		);
	}
}